// extracted by mini-css-extract-plugin
export default {"container":"snsListItem_container__mY+aD","titleSection":"snsListItem_titleSection__rziVe","iconTitle":"snsListItem_iconTitle__wnzSh","icon":"snsListItem_icon__AQiOD"};